"use client";

import { useEffect } from "react";
import { Drawer as DrawerPrimitive } from "vaul";

export interface DrawerRootProps {
  activeSnapPoint?: number | string | null;
  setActiveSnapPoint?: (snapPoint: number | string | null) => void;
  children?: React.ReactNode;
  open?: boolean;
  closeThreshold?: number;
  noBodyStyles?: boolean;
  onOpenChange?: (open: boolean) => void;
  shouldScaleBackground?: boolean;
  setBackgroundColorOnScale?: boolean;
  scrollLockTimeout?: number;
  fixed?: boolean;
  dismissible?: boolean;
  onDrag?: (event: React.PointerEvent<HTMLDivElement>, percentageDragged: number) => void;
  onRelease?: (event: React.PointerEvent<HTMLDivElement>, open: boolean) => void;
  modal?: boolean;
  nested?: boolean;
  onClose?: () => void;
  direction?: "top" | "bottom" | "left" | "right";
  defaultOpen?: boolean;
  repositionInputs?: boolean;
}

const Root = ({ shouldScaleBackground = true, children, fixed, ...props }: DrawerRootProps) => {
  // https://github.com/radix-ui/primitives/issues/1859#issuecomment-1771356816
  useEffect(() => {
    // Disable Radix ui dialog pointer events lockout
    setTimeout(() => (document.body.style.pointerEvents = ""), 0);
  });

  return (
    <DrawerPrimitive.Root shouldScaleBackground={shouldScaleBackground} handleOnly={false} fixed={true} {...props}>
      {children}
    </DrawerPrimitive.Root>
  );
};

Root.displayName = "Root";

export default Root;
